import React from 'react';
import * as dto from 'client/dto';
import RiskOverviewDetailColumnListItem from '../RiskOverviewDetailColumnListItem';

type TransmissionDetailedPossibilityProps = {
  transmissibility: dto.TransmissibilityDisruptionFactorType;
  diseaseName: string;
  locationName: string;
  parentLocationName?: string;
};

const TransmissionDetailedPossibility: React.FC<TransmissionDetailedPossibilityProps> = ({
  transmissibility,
  diseaseName,
  locationName,
  parentLocationName,
}) => {
  const transmissibilityStatements: string[] = [];
  switch (transmissibility) {
    case dto.TransmissibilityDisruptionFactorType.PossibleViaHumanToHuman: {
      transmissibilityStatements.push(
        `Infected individuals commonly spread ${diseaseName} directly to others who do not have immunity`
      );
      break;
    }
    case dto.TransmissibilityDisruptionFactorType.PossibleViaEnvironmentLocally: {
      transmissibilityStatements.push(
        `Infected individuals in ${locationName} could spread ${diseaseName} to others via the environment (e.g insects, water, soil, etc.)`
      );
      break;
    }
    case dto.TransmissibilityDisruptionFactorType.PossibleViaEnvironment: {
      transmissibilityStatements.push(
        `Infected individuals in regions or all of ${parentLocationName} could spread ${diseaseName} to others via the environment (e.g insects, water, soil, etc.). There is no specific data on whether spread can occur in ${locationName}.`
      );
      break;
    }
    case dto.TransmissibilityDisruptionFactorType.LimitedViaHumanToHuman: {
      transmissibilityStatements.push(
        `Infected individuals could spread ${diseaseName} directly to others who do not have immunity; however, spread may be limited due to how this disease is transmitted`
      );
      break;
    }
    case dto.TransmissibilityDisruptionFactorType.Unlikely: {
      transmissibilityStatements.push(
        `Based on historic data, infected individuals in ${locationName} are unlikely to spread ${diseaseName} (via the environment)`
      );
      break;
    }
    case dto.TransmissibilityDisruptionFactorType.NotPossibleUnlessLocally: {
      transmissibilityStatements.push(
        `It is not possible for an infected individual to spread ${diseaseName} to others or the environment (e.g insects, water, soil, etc.)`
      );
      transmissibilityStatements.push(
        `Previous activity in ${locationName} indicates that humans could potentially acquire ${diseaseName} locally from the environment.`
      );
      break;
    }
    case dto.TransmissibilityDisruptionFactorType.NotPossible: {
      transmissibilityStatements.push(
        `It is not possible for an infected individual to spread ${diseaseName} to others or the environment (e.g insects, water, soil, etc.)`
      );
      break;
    }
  }
  return (
    <>
      {transmissibilityStatements.map((x, index) => (
        <RiskOverviewDetailColumnListItem key={index} itemText={x} />
      ))}
    </>
  );
};

export default TransmissionDetailedPossibility;
